// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"272":"d724de2c","347":"e3778013","884":"84e17d52","897":"9589ed1d","901":"17d3a692","966":"6ab75925"}[chunkId] + ".chunk.css";
};